import { render } from "./ViewerSlideshow.vue?vue&type=template&id=2426c97e&scoped=true"
import script from "./ViewerSlideshow.vue?vue&type=script&lang=js"
export * from "./ViewerSlideshow.vue?vue&type=script&lang=js"

import "./ViewerSlideshow.vue?vue&type=style&index=0&id=2426c97e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2426c97e"]])

export default __exports__